// extracted by mini-css-extract-plugin
module.exports = {"container":"page_container__psc4n","page":"page_page__U5ZUe","title":"page_title__xkqgY","image":"page_image__xgARj","header_image":"page_header_image__uBUnW"};